// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__23hBU","paypalobjects":"styles_paypalobjects__2j7wm","paypal":"styles_paypal__1i6ZH"};